import TreeViewComponent from "../components/TreeViewComponent";
import { useCreateProgramsTreeData } from '../hooks/useCreateProgramsTreeData';
import { useAdminActions } from '../hooks/useAdminActions';
import { useFilterTreeData } from "../hooks/useFilterTreeData";


export default function ProgramList({ allowDrop, visibleDelete, onContextMenuClick, handleDelete, showEditMenu, searchString }) {
    const { myArray: treeData } = useCreateProgramsTreeData();
    const filteredTreeData  = useFilterTreeData(treeData, searchString)
    const { addAdminProgram, reorderProgram } = useAdminActions();


    const handleDrop = (newTree, { dragSourceId, dropTargetId, dragSource }) => {
        if (allowDrop) {
            // if (dragSource?.parent === dropTargetId) {
            //     reorderProgram(newTree, dropTargetId)
            //     // console.log(newTree)
            // } else {
                addAdminProgram(dragSourceId, dropTargetId)
            // }
        }
    };

    // filteredTreeData.sort((a, b) => {
    //     const idxA = a.data.idx; // Convert names to uppercase for case-insensitive sorting
    //     const idxB = b.data.idx

    //     if (idxA < idxB) {
    //         return -1;
    //     }
    //     if (idxA > idxB) {
    //         return 1;
    //     }
    //     return 0;
    // });


    return (
        <div >
            <div>
                <TreeViewComponent
                    treeData={filteredTreeData}
                    handleDrop={handleDrop}
                    onDelete={handleDelete}
                    visibleDelete={visibleDelete}
                    onContextMenuClick={onContextMenuClick}
                    showEditMenu={showEditMenu}
                />
            </div>
        </div>

    )
}
